export default __webpack_public_path__ + "static/media/vegan_green_burrito.ee8fbd62.jpg";